<div id="profile" class="page-layout simple tabbed">

    <!-- HEADER -->
    <div class="header p-24" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row"
        fxLayoutAlign.gt-sm="space-between end">

        <div class="user-info" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="start center">
            <img class="profile-image avatar huge" src="assets\images\avatars\default.png"
                [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
            <div class="name" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                {{ getCliente().razonSocial }}
            </div>
        </div>
        <!--
     <div class="actions" fxLayout="row" fxLayoutAlign="end center" [@animate]="{value:'*',params:{delay:'200ms'}}">
            <button mat-raised-button color="accent" aria-label="Follow">Follow</button>
            <button mat-raised-button color="primary" aria-label="Send Message">Send Message</button>
        </div>

-->
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">

        <mat-tab-group dynamicHeight="true">

            <mat-tab label="{{'PROFILE.DATOS_PERSONALES' | translate}}">
                <!--   <profile-timeline></profile-timeline> -->

                <!--  DATOS PERSONALES -->

                <div id="register" fxLayout="column">

                    <div id="register-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

                        <div id="register-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

                            <div class="title">{{ 'REGISTER.TITLE' | translate}}</div>

                            <form name="registerForm" [formGroup]="registerForm" novalidate>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'REGISTER.BUSINESS_NAME' | translate}}</mat-label>
                                    <input matInput formControlName="razonSocial" [(ngModel)]="getCliente().razonSocial">
                                    <mat-icon matSuffix class="secondary-text">business</mat-icon>
                                    <mat-error>
                                        {{ 'REGISTER.BUSINESS_NAME_REQUIRED' | translate}}
                                    </mat-error>
                                </mat-form-field>

                            

                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="updateClient()">
                                    {{ 'REGISTER.ACTUALIZAR' | translate}}
                                </button>

                              

                            </form>

                        </div>

                    </div>
                </div>




                <!-- HASTA AQUI LOS DATOS PERSONALES -->
            </mat-tab>
            <!-- DATOS DE PAGO / TARJETA -->
            <mat-tab *ngIf="false" label="{{'PROFILE.PAYMENT' | translate }}">
                <div id="register" fxLayout="column">
                    <div id="register-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
                        <div id="register-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
                            <div class="title">{{ 'PROFILE.CARD' | translate}}</div>
                            <!--<a>{{ cliente.tarjetaPago.numero }}</a><br>
                            <a>{{ cliente.tarjetaPago.mes }}</a><br>
                            <a>{{ cliente.tarjetaPago.anyo }}</a><br>
                            <a>{{ cliente.tarjetaPago.cvv }}</a><br>-->
                            <form name="registerFormTarjeta" [formGroup]="registerFormTarjeta" novalidate>
                                <mat-label *ngIf="cliente.tarjetaPago.numero !== ''">Método Pago Actual:
                                   <!-- **{{ cliente.tarjetaPago.numero.substr(12)}} --> 
                                    {{ cliente.tarjetaPago.numero }}
                                </mat-label>
                                <mat-label *ngIf="cliente.tarjetaPago.numero === ''">Actualmente no tiene ningún método
                                    de Pago</mat-label>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'PROFILE.PAYMENT_CARD_NUMBER' | translate}}</mat-label>
                                    <input matInput formControlName="numeroTarjeta">
                                    <mat-icon matSuffix class="secondary-text">credit_card</mat-icon>
                                    <mat-error *ngIf="!validarTarjeta(registerFormTarjeta.get('numeroTarjeta').value) &&
                                    registerFormTarjeta.get('numeroTarjeta').hasError('cardNumberNotValid')">
                                        {{ 'PROFILE.PAYMENT_CARD_NOT_VALID' | translate}}
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'PROFILE.PAYMENT_CARD_MONTH' | translate}}</mat-label>
                                    <input type="number" max="12" min="1" matInput formControlName="mesTarjeta">
                                    <mat-icon matSuffix class="secondary-text">today</mat-icon>
                                    <mat-error
                                        *ngIf="registerFormTarjeta.get('mesTarjeta').hasError('cardMonthNotValid')">
                                        {{ 'PROFILE.PAYMENT_CARD_MONTH_NOT_VALID' | translate}}
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'PROFILE.PAYMENT_CARD_YEAR' | translate}}</mat-label>
                                    <input type="number" max="99" min="20" matInput formControlName="anyoTarjeta">
                                    <mat-icon matSuffix class="secondary-text">today</mat-icon>
                                    <mat-error
                                        *ngIf="registerFormTarjeta.get('anyoTarjeta').hasError('cardYearNotValid')">
                                        {{ 'PROFILE.PAYMENT_CARD_YEAR_NOT_VALID' | translate }}
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'PROFILE.PAYMENT_CARD_CVV' | translate}}</mat-label>
                                    <input type="text" matInput formControlName="cvvTarjeta">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                    <mat-error *ngIf="registerForm.get('cvvTarjeta').hasError('cardCvcNotValid')">
                                        {{ 'PROFILE.CARD_CVV_REQUIRED' | translate}}
                                    </mat-error>
                                </mat-form-field>

                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="updateTarjeta()"
                                    [disabled]="this.registerFormTarjeta.invalid">
                                    {{ 'PROFILE.ACTUALIZAR' | translate}}
                                </button>

                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="irSuscripcion()">
                                    {{ 'PROFILE.SUBSCRIPTION' | translate}}
                                </button>

                            </form>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <!-- CAMBIAR PASSWORD -->
            <mat-tab *ngIf="false" label="{{'PROFILE.PASSWORD_TAB' | translate }}">
                <div id="register" fxLayout="column">
                    <div id="register-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
                        <div id="register-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
                            <div class="title">{{ 'PROFILE.PASSWORD_TITLE' | translate}}</div>
                            <form name="registerFormPassword" [formGroup]="registerFormPassword" novalidate>
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'PROFILE.PASSWORD_OLD' | translate}}</mat-label>
                                    <input matInput type="password" formControlName="oldclave">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                    <mat-error>
                                        {{ 'REGISTER.PASSWORD_REQUIRED' | translate}}
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'PROFILE.PASSWORD_NEW' | translate}}</mat-label>
                                    <input matInput type="password" formControlName="clave">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                    <mat-error>
                                        {{ 'REGISTER.PASSWORD_REQUIRED' | translate}}
                                    </mat-error>
                                </mat-form-field>

                              

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'REGISTER.PASSWORD_CONFIRMATION' | translate}}</mat-label>
                                    <input matInput type="password" formControlName="passwordConfirm">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                    <mat-error *ngIf="registerFormPassword.get('passwordConfirm').hasError('required')">
                                        {{ 'REGISTER.PASSWORD_CONFIRMATION_REQUIRED' | translate}}
                                    </mat-error>
                                    <mat-error
                                        *ngIf="!registerFormPassword.get('passwordConfirm').hasError('required') &&
                                                           registerFormPassword.get('passwordConfirm').hasError('passwordsNotMatching')">
                                        {{ 'REGISTER.PASSWORD_CONFIRMATION_MATCH' | translate}}
                                    </mat-error>
                                </mat-form-field>

                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="updatePassword()"
                                    [disabled]="registerFormPassword.invalid">
                                    {{ 'REGISTER.ACTUALIZAR' | translate}}
                                </button>


                            </form>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <!-- FACE LOGIN -->

            <mat-tab *ngIf="false" label="FACE LOGIN">
                <div id="register" fxLayout="column">
                    <div id="register-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
                        <div id="register-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
                            <div class="title">FACE LOGIN</div>
                            <form name="registerFormface" [formGroup]="registerFormPassword" novalidate>
                                <button mat-raised-button color="accent" class="submit-button"
                                aria-label="UPDATE AN ACCOUNT" (click)="facelogin()" *ngIf="!muestraCamara">
                                UPDATE FACE LOGIN
                            </button>
                            <p align="center" *ngIf="muestraCamara">{{ textoFace }}</p>
                            <div class="logo">
                                <img  width="250px" height="200px" [src]="value"  *ngIf="haveFace">
                            </div>
                            <p>
                              <video  #video id="myvideo" class="vid" autoplay  *ngIf="muestraCamara"></video>
                            </p>
                            <button mat-raised-button color="accent" class="submit-button"
                            aria-label="UPDATE AN ACCOUNT" (click)="cancelfacelogin()" *ngIf="muestraCamara">
                            CANCEL
                            </button>
                            <button mat-raised-button  color="red" class="submit-button" aria-label="LOG IN"
                            (click)="haveFace = false" *ngIf="haveFace">
                                NO FACE LOGIN
                            </button>
                            <button mat-raised-button  color="red" class="submit-button" aria-label="LOG IN"
                            (click)="updateFace()" *ngIf="haveFace">
                                ACTUALIZAR FACE LOGIN
                            </button>
                           </form>
                           </div>
                           </div>
                           </div>
                           
                           </mat-tab>

            <!-- FIN FACE LOGIN -->


            <mat-tab *ngIf="false" label="Administrador">
                <div id="register" fxLayout="column">
                    <div id="register-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

                        <div id="register-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
                            <div class="title">Administrar Clientes</div>
                            <form name="registerFormCliente" [formGroup]="registerFormCliente" novalidate>

                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <input matInput type="text" formControlName="emailCliente">
                                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Plan</mat-label>
                                    <input matInput type="text" formControlName="planCliente">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Subscripcion</mat-label>
                                    <input matInput type="text" formControlName="subscripcionCliente">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Nueva Password</mat-label>
                                    <input matInput type="text" formControlName="passCliente">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                </mat-form-field>

                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="verCliente()">
                                    Ver Cliente
                                </button>
                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="accederPanelCliente()">
                                    Acceder a su panel de control
                                </button>
                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="updatePlanCliente()">
                                    Actualizar Plan
                                </button>
                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="updateSubscripcionCliente()">
                                    Actualizar Subscripcion
                                </button>
                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="updatePassCliente()">
                                    Actualizar Password
                                </button>
                                <button mat-raised-button color="accent" class="submit-button"
                                    aria-label="UPDATE AN ACCOUNT" (click)="borrarCliente()">
                                    Borrar
                                </button>

                            </form>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <!--
      <mat-tab label="Photos & Videos">
                <profile-photos-videos></profile-photos-videos>
            </mat-tab> 
-->




        </mat-tab-group>

    </div>
    <!-- / CONTENT -->

</div>